
export default {


    data(){
        return {
            page : 1,        
            pagelength : 0,
            grouping : 7 ,
            pageActive : 1,
            num : 0
        }
    },
    created(){
        this.grouping = this.pageSize / 10 < 1 ? 1 : Math.ceil(this.pageSize / 10)
        this.pagelength = this.grouping < 9 ? 1 : Math.ceil(this.pageSize / this.grouping) < 1 ? 1 : Math.ceil(this.pageSize / this.grouping)
    },
    methods: {
        pagenext(){
            if(this.page == this.pagelength) return;
            this.num+=this.grouping
        },
        thisPage(e){
            this.pageActive = e;
            this.$emit('pageActive',this.pageActive);
        }
    },



}